// extracted by mini-css-extract-plugin
export var card = "_lv-5";
export var cardSelected = "_lv-4";
export var image = "_lv-3";
export var modal = "_lv-0";
export var modalContent = "_lv-1";
export var table = "_lv-2";